import React, { Component } from "react";
import "./CustomHeroCard.css";

export default class CustomHeroCardButtonCol extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
  }

  handleMouseEnter = () => {
    this.setState({ hover: true });
  };
  handleMouseLeave = () => {
    this.setState({ hover: false });
  };


handleClick = () => {
  const buttonColor = this.props.messegenerSettings?.color;
  let parsed;
  try {
    parsed = JSON.parse(this.props.btn.value);
    
  } catch (e) {    
    return this.props.action(this.props.btn);
  }
  if (!parsed.url) {    
    return this.props.action(this.props.btn);
  }
  const btnCopy = { ...this.props.btn };

  try {
    if (buttonColor) {
      
      const cleanUrl = parsed.url.replace(/&amp;/g, "&");
      const urlObj = new URL(cleanUrl, window.location.origin);
      urlObj.searchParams.set("buttonColor", buttonColor); // no duplicate

      const finalUrl = urlObj.toString();
      parsed.url = finalUrl;
      btnCopy.value = JSON.stringify(parsed);
    } else {
      console.warn(" Button color not found, skipping param add");
    }
  } catch (e) {
    console.error(" URL Processing Error:", e);
    return this.props.action(this.props.btn);
  }
  this.props.action(btnCopy);

};
handleKeyDown = (e) => {
   if (e.key === "Enter" || e.key === " ") { e.preventDefault(); this.props.action(this.props.btn); } };
  render() {
    return (
      <button type="button"
      aria-label={this.props.btn.title}
        className="herocard-button herocard-button-col list-button"
        key={this.props.btn.title}
        style={{
          backgroundColor: this.props.botSettings.colours.heroButtonBackground,
          color: this.props.botSettings.colours.heroButtonText,
          ...(this.state.hover && {
            backgroundColor:
              this.props.botSettings.colours.heroButtonBackgroundHover,
            color: this.props.botSettings.colours.heroButtonTextHover,
          }),
        }}
        onKeyDown={this.handleKeyDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleClick}
      >
        {this.props.btn.title === "Details"
          ? "View Details"
          : this.props.btn.title}
      </button>
    );
  }
}
